class ConsumerHeadingController  {
    constructor() {
        //this.consumer = this.container.consumer;
    }
    add(){return (this.container.add || this.container.prompt.add)();}
}

class ConsumerHeading{
    constructor(){
        this.require= {
            container: '^consumerContainer'
        };
        this.bindings= {
            query: '<'
        };
        this.controller = ConsumerHeadingController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumer-heading.html'
    }
}

angular.module('emun.consumer').component('consumerHeading', new ConsumerHeading());

export default   ConsumerHeading;